module.exports = {
    "ts": 0,
    "data": {
    }
};